import { styled } from 'goober';
import React, { forwardRef } from 'react';
export var WidgetStyled = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        background: theme.colors.ui.white,
        borderRadius: '6px',
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
    });
});
export var WidgetBox = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '8px',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%;',
    });
});
export var WidgetTitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        paddingBottom: '16px',
        fontSize: '12px',
        color: theme.colors.ui.dark,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    });
});
export var WidgetMenuContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: '8px',
        right: '5px',
        width: '40px',
        zIndex: '101',
    });
});
export var WidgetMenuTrigger = styled('div', React.forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        cursor: 'pointer',
        backgroundColor: '#fff',
        color: theme.colors.ui.dark,
        opacity: 0,
        textAlign: 'center',
        //height: '18px',
        '&:hover': {
            opacity: 1,
        },
    });
});
export var WidgetContent = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, _b = _a.$overflow, $overflow = _b === void 0 ? 'auto' : _b;
    return ({
        overflow: $overflow,
        contain: 'layout',
        width: '100%',
        height: '100%',
    });
});
export var ChartContent = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 10px)',
        width: 'calc(100% - 10px)',
    });
});
export var ChartLineButton = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '28px',
        height: '28px',
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'start',
        cursor: 'pointer',
    });
});
export var TagSlicerButton = styled('div')(function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        outline: 'none',
        borderRadius: '5px',
        backgroundColor: theme.colors.neutral.w50,
        border: $active ? "2px solid ".concat(theme.colors.primary.w500) : '2px solid transparent',
        position: 'relative',
        cursor: 'pointer',
        padding: '0px 8px',
        fontSize: '10px',
    });
});
export var TagSlicerButtonTitle = styled('span')(function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return ({
        margin: 0,
        fontSize: '12px',
        color: $active ? theme.colors.primary.w500 : theme.colors.ui.dark,
        textAlign: 'center',
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    });
});
export var TagDropzoneGrid = styled('div')(function (_a) {
    var theme = _a.theme, $visible = _a.$visible, $rowNumber = _a.$rowNumber, $columnNumber = _a.$columnNumber;
    return ({
        position: 'absolute',
        visibility: $visible ? 'visible' : 'hidden',
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateRows: "repeat(".concat($rowNumber, ", 1fr)"),
        gridTemplateColumns: "repeat(".concat($columnNumber, ", 1fr)"),
    });
});
export var TagDropzone = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $hovered = _a.$hovered, $selected = _a.$selected, $rowSpan = _a.$rowSpan, $colSpan = _a.$colSpan;
    return ({
        contain: 'layout',
        overflow: 'auto',
        opacity: $hovered ? 1 : 0.5,
        borderRadius: '6px',
        borderStyle: $selected ? 'solid' : 'dashed',
        borderWidth: '1px',
        borderColor: $selected ? theme.colors.primary.w500 : theme.colors.neutral.w500,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '8px',
        padding: '4px',
        margin: '4px',
        gridRow: $rowSpan !== undefined ? "span ".concat($rowSpan) : 'auto',
        gridColumn: $colSpan !== undefined ? "span ".concat($colSpan) : 'auto',
        justifyContent: 'flex-start',
        alignItems: 'start',
    });
});
export var TagDropzonePlaceholder = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        alignSelf: 'center',
        textAlign: 'center',
        fontSize: '11px',
        color: theme.colors.neutral.w700,
        userSelect: 'none',
    });
});
export var TagDropzoneButton = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        bottom: '4px',
        left: '4px',
    });
});
export var PivotAddButton = styled('div')(function (_a) {
    var theme = _a.theme, $place = _a.$place;
    return ({
        position: 'absolute',
        bottom: $place === 'bottom' ? '0px' : '32px',
        right: $place === 'right' ? '0px' : '32px',
    });
});
export var SingleValueData = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '48px',
        fontWeight: 'bold',
        color: theme.colors.ui.dark,
    });
});
export var SingleValueDataInputContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    });
});
export var SingleValueDataInput = styled('input')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '48px',
        fontWeight: 'bold',
        color: theme.colors.ui.dark,
        background: 'none',
        border: 'none',
        outline: 'none',
        width: '100%',
        padding: '0px',
    });
});
export var SingleValueDataInputButtonContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
    });
});
export var SingleValueComparisonData = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: '12px',
        marginTop: '15px',
        lineHeight: 1.6,
    });
});
export var SingleValueComparisonNumber = styled('span')(function (_a) {
    var theme = _a.theme, _b = _a.$positive, $positive = _b === void 0 ? true : _b;
    return ({
        padding: '4px 8px',
        borderRadius: '4px',
        fontWeight: 800,
        backgroundColor: $positive ? theme.colors.success.w50 : theme.colors.error.w50,
        color: $positive ? theme.colors.success.w500 : theme.colors.error.w500,
    });
});
export var GridLockButton = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        paddingLeft: '10px',
        display: 'flex',
        cursor: 'pointer',
    });
});
